import { IKeyValuePair } from "../../../Core/Portlets/Utils/GuidToPortletInfoMap";

export class UpdateTranslationModel {
	constructor() {
		this.Translations = [];
	}

	Id: number;
	Translations: Array<IKeyValuePair<string, string>>;
}